import { ONE_GB, ONE_KB, ONE_MB, ONE_TB } from "@app/constants/file";

export function getUserFriendlyFileSize(fileSize: number): string {
  if (fileSize < ONE_KB) {
    return fileSize.toString() + 'B';
  } else if (fileSize >= ONE_KB && fileSize < ONE_MB) {
    return (fileSize / ONE_KB).toFixed(0).toString() + 'KB';
  } else if (fileSize >= ONE_MB && fileSize < ONE_GB) {
    return (fileSize / ONE_MB).toFixed(0).toString() + 'MB';
  } else if (fileSize >= ONE_GB && fileSize < ONE_TB) {
    return (fileSize / ONE_GB).toFixed(0).toString() + 'GB';
  } else {
    return (fileSize / ONE_TB).toFixed(0).toString() + 'TB';
  }
}
